import FlourishDeck from "./FlourishDeck";

const ShoppertainmentProposal = () => <FlourishDeck partner="shoppertainment" />;

export default ShoppertainmentProposal;
